// DESCRIPTION: BlockInfo related models & functions

(function (mod){ //[HyperMD] UMD patched!
  /*commonjs*/  ("object"==typeof exports&&"undefined"!=typeof module) ? mod(null, exports, require("./normalize"), require("./parse")) :
  /*amd*/       ("function"==typeof define&&define.amd) ? define(["require","exports","./normalize","./parse"], mod) :
  /*plain env*/ mod(null, (this.HyperMD.BlockInfoAddon = this.HyperMD.BlockInfoAddon || {}), HyperMD.BlockInfoNormalize, HyperMD.BlockInfoParse);
})(function (require, exports, normalize_1, parse_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.extractCommandFromBlockInfo = void 0;
    Object.defineProperty(exports, "normalizeBlockInfo", { enumerable: true, get: function () { return normalize_1.default; } });
    Object.defineProperty(exports, "parseBlockInfo", { enumerable: true, get: function () { return parse_1.default; } });
    exports.extractCommandFromBlockInfo = function (info) {
        return info.attributes["cmd"] === true ? info.language : info.attributes["cmd"];
    };
});
